import { customActivityButton } from './ActivityButton';

/** Button to view and perform a "Dislike" action on an item. */
export default customActivityButton('Dislike', 'Dislike', 'You disliked', 'Disliked');
